<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <router-view class="height-full" />
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
export default {
  name: "wrapper",

  computed: {
    ...mapGetters(["getScreen"]),
  },
};
</script>

<style>
</style>